import chroma from 'chroma-js';

export const DEFAULT_IDLE_COLOR = '#94A3B8';
export const DEFAULT_SUCCESS_COLOR = '#10B981';
export const DEFAULT_ERROR_COLOR = '#EF4444';

const isValidHex = (value) =>
  typeof value === 'string' && /^#[0-9A-Fa-f]{6}$/.test(value);

const safeChroma = (color, fallback) => {
  try {
    return chroma(color || fallback);
  } catch {
    return chroma(fallback);
  }
};

/**
 * Resolve business semantic colors with legacy fallbacks from main/sec/accent.
 */
export function getSemanticColors(businessData = {}, theme = null) {
  const mainColor = businessData?.mainColor || theme?.palette?.primary?.main || '#000000';
  const secColor = businessData?.secColor || theme?.palette?.secondary?.main || '#696969';
  const accentColor = businessData?.accentColor || '';

  let idleColor = businessData?.idleColor;
  if (!isValidHex(idleColor)) {
    idleColor = DEFAULT_IDLE_COLOR;
  }

  let successColor = businessData?.successColor;
  if (!isValidHex(successColor)) {
    successColor = isValidHex(secColor) ? secColor : DEFAULT_SUCCESS_COLOR;
  }

  let errorColor = businessData?.errorColor;
  if (!isValidHex(errorColor)) {
    try {
      errorColor = safeChroma(mainColor, DEFAULT_ERROR_COLOR).darken(0.3).hex();
    } catch {
      errorColor = DEFAULT_ERROR_COLOR;
    }
  }

  return {
    mainColor,
    secColor,
    accentColor,
    idleColor,
    successColor,
    errorColor,
  };
}

/**
 * Resolve a block/header color token to a CSS color string.
 */
export function resolveBlockColorToken(color, businessData = {}, theme = null) {
  const semantic = getSemanticColors(businessData, theme);

  if (color === 'mainColor') return semantic.mainColor;
  if (color === 'secColor') return semantic.secColor;
  if (color === 'accentColor') return semantic.accentColor || semantic.mainColor;
  if (color === 'idleColor') return semantic.idleColor;
  if (color === 'successColor') return semantic.successColor;
  if (color === 'errorColor') return semantic.errorColor;
  if (typeof color === 'string' && /^(#|rgb|hsl|color\()/i.test(color)) return color;

  return semantic.mainColor;
}
